/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */

function CurrencyListing({currencyListingProps}) {
const {currencyRows,
    cashSales,
handleCashSaleChange
   }=currencyListingProps;


  return (
    <>
         {currencyRows.length>0?  <div className="cash-sales-section">
            <span className='large-button-text-medium'>Cash Sales by Currency</span>
             
             <div className="currency-grid sm-scrollbar margTop8"  style={{overflowY:'scroll'}}>
               {currencyRows.map((row) => (
         
         
                     <div key={row} className="currency-field">
                       <label className={`${cashSales[row]>0 ? 'small-label-text' : ''}`}>{row}</label>
                    <input
                      type="text"
                      className={cashSales[row] > 0 ? 'edit-input-valuein' : 'edit-input'}
                      value={cashSales[row] ?? ''}  
                      placeholder="0"
                      onChange={(e) => {
                        let val = e?.target?.value;
                        val = val?.replace(/[^0-9.]/g, "");
                        const parts = val.split(".");
                        if (parts.length > 2) {
                          val = parts[0] + "." + parts.slice(1).join("");
                        }

                        handleCashSaleChange(row, val);
                      }}
                      />
                     </div>
                   
                
               ))}
             </div>
           </div>:<><h6>No Currencies found</h6></>}
    </>
  );
}

export default CurrencyListing;
